var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vue-tinymce"}},[(_vm.showEditor)?_c('vue-tinymce',{attrs:{"setting":_vm.setting},model:{value:(_vm.editorVlaue),callback:function ($$v) {_vm.editorVlaue=$$v},expression:"editorVlaue"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }